import { render, staticRenderFns } from "./SavePurchasingRecord.vue?vue&type=template&id=686a3d6a&scoped=true&"
import script from "./SavePurchasingRecord.vue?vue&type=script&lang=js&"
export * from "./SavePurchasingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686a3d6a",
  null
  
)

export default component.exports